import script from "./wasteDisposal.vue?vue&type=script&setup=true&lang=js"
export * from "./wasteDisposal.vue?vue&type=script&setup=true&lang=js"

import "./wasteDisposal.vue?vue&type=style&index=0&id=f5e0aaa6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f5e0aaa6"]])

export default __exports__